import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { CardComponent } from '../../../../../shared/components/card/card.component';
import { RouteConfigurationChangeLog, RouteConfigurationWithSchema } from '../../../../../shared/models/route';
import { CardContentDirective } from '../../../../../shared/components/card/card-content.directive';
import { RootRoute, SettingsRoute } from '../../../../../shared/models/angular-routing';
import { RoutesService } from '../../../../../data/routes/routes.service';
import { ToastService } from '../../../../../shared/services/toast.service';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow, MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource,
} from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { RouteConfigurationChangesComponent } from './route-configuration-changes/route-configuration-changes.component';
import { RouteGeometryChangesComponent } from './route-geometry-changes/route-geometry-changes.component';

@Component({
  selector: 'app-route-configuration-change-log',
  imports: [
    MatProgressSpinner,
    CardComponent,
    CardContentDirective,
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatCell,
    MatCellDef,
    DatePipe,
    MatHeaderRow,
    MatRow,
    MatRowDef,
    MatHeaderRowDef,
    RouteConfigurationChangesComponent,
    RouteGeometryChangesComponent,
  ],
  templateUrl: './route-configuration-change-log.component.html',
  styleUrl: './route-configuration-change-log.component.scss',
})
export class RouteConfigurationChangeLogComponent implements OnInit {
  configurationId: number;
  configuration: RouteConfigurationWithSchema;
  isLoading = true;
  dataSource: MatTableDataSource<RouteConfigurationChangeLog> = new MatTableDataSource([]);

  displayedColumns: string[] = ['saved', 'changedBy', 'note'];
  versionDetail: RouteConfigurationChangeLog;

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly toastService: ToastService,
    private readonly routeService: RoutesService
  ) {}

  ngOnInit() {
    this.configurationId = +this.activatedRoute.snapshot.paramMap.get('configurationId');

    Promise.all([
      this.routeService.getRouteConfiguration(this.configurationId),
      this.routeService.getRouteConfigurationChangeLog(this.configurationId),
    ])
      .then(responses => {
        const [configurationResponse, changelog] = responses;
        this.configuration = configurationResponse.data;
        this.dataSource.data = changelog;
        this.isLoading = false;
      })
      .catch(error => {
        this.isLoading = false;
        this.toastService.long('Error while loading route configuration/changelog');
      });
  }

  navigateBack(): void {
    this.router.navigate([`/${RootRoute.SETTINGS}`, SettingsRoute.MANAGE_ROUTES]).then();
  }

  backToVersionList() {
    this.versionDetail = undefined;
  }

  showVersionDetail(detail: RouteConfigurationChangeLog) {
    this.versionDetail = detail;
  }
}
